module.exports = __webpack_public_path__ + "img/error.0e16122d.png";